// Optimized Gallery Modal Module - Performance Focused
export function initializeGalleryModal() {
  const modal = document.getElementById('galleryModal');
  const modalImage = document.getElementById('modalImage');
  const galleryLoading = document.getElementById('galleryLoading');
  const galleryCounter = document.getElementById('galleryCounter');
  const currentImageIndex = document.getElementById('currentImageIndex');
  const totalImages = document.getElementById('totalImages');
  const galleryImageTitle = document.getElementById('galleryImageTitle');
  const galleryImageDescription = document.getElementById('galleryImageDescription');
  const galleryImageInfo = document.getElementById('galleryImageInfo');
  const galleryButtons = document.querySelectorAll('.gallery-btn');

  // Early return if essential elements are missing
  if (!modal || !modalImage || !galleryButtons.length) {
    return;
  }

  // Simple state management
  let currentIndex = 0;
  let allImages = [];
  let isLoading = false;

  // Initialize gallery data once
  function initializeGallery() {
    allImages = Array.from(galleryButtons).map((btn, index) => {
      const imageSrc = btn.getAttribute('data-image');
      const overlay = btn.closest('.gallery-overlay');
      const content = overlay ? overlay.querySelector('.gallery-content') : null;
      
      let title = 'Gallery Image';
      let description = 'Premium pool construction by Cilek Pool';

      if (content) {
        const titleElement = content.querySelector('.gallery-title');
        const descElement = content.querySelector('p');
        if (titleElement) title = titleElement.textContent.trim();
        if (descElement && descElement !== titleElement) description = descElement.textContent.trim();
      }

      return {
        src: imageSrc,
        alt: title,
        title: title,
        description: description,
        index: index
      };
    });

    if (totalImages) {
      totalImages.textContent = allImages.length;
    }
  }

  // Optimized image loading with caching
  const imageCache = new Map();
  
  function loadImage(src) {
    if (imageCache.has(src)) {
      return Promise.resolve(imageCache.get(src));
    }

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        imageCache.set(src, img);
        resolve(img);
      };
      img.onerror = reject;
      img.src = src;
    });
  }

  // Show loading state
  function showLoading() {
    if (galleryLoading) {
      galleryLoading.classList.remove('hidden');
      galleryLoading.style.display = 'flex';
    }
    if (modalImage) {
      modalImage.style.opacity = '0.3';
    }
    isLoading = true;
  }

  // Hide loading state
  function hideLoading() {
    if (galleryLoading) {
      galleryLoading.classList.add('hidden');
      galleryLoading.style.display = 'none';
    }
    if (modalImage) {
      modalImage.style.opacity = '1';
    }
    isLoading = false;
  }

  // Update modal content
  function updateModalContent(imageData) {
    if (modalImage) {
      modalImage.src = imageData.src;
      modalImage.alt = imageData.alt;
    }
    
    if (galleryImageTitle) {
      galleryImageTitle.textContent = imageData.title;
    }
    
    if (galleryImageDescription) {
      galleryImageDescription.textContent = imageData.description;
    }
    
    if (currentImageIndex) {
      currentImageIndex.textContent = currentIndex + 1;
    }
  }

  // Navigate to specific image
  function goToImage(index) {
    if (isLoading || index < 0 || index >= allImages.length) return;
    
    currentIndex = index;
    const imageData = allImages[index];
    
    showLoading();
    updateModalContent(imageData);
    
    // Preload image
    loadImage(imageData.src)
      .then(() => {
        hideLoading();
        if (galleryImageInfo) {
          galleryImageInfo.classList.add('show');
        }
      })
      .catch(() => {
        hideLoading();
        console.warn('Failed to load image:', imageData.src);
      });
  }

  // Navigation functions
  function nextImage() {
    if (isLoading) return;
    const nextIndex = (currentIndex + 1) % allImages.length;
    goToImage(nextIndex);
  }

  function prevImage() {
    if (isLoading) return;
    const prevIndex = (currentIndex - 1 + allImages.length) % allImages.length;
    goToImage(prevIndex);
  }

  // Event listeners
  function setupEventListeners() {
    // Gallery button clicks
    galleryButtons.forEach((btn, index) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        goToImage(index);
      });
    });

    // Navigation buttons
    const prevBtn = document.getElementById('galleryPrev');
    const nextBtn = document.getElementById('galleryNext');
    
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        prevImage();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        nextImage();
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (!modal.classList.contains('show')) return;
      
      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          prevImage();
          break;
        case 'ArrowRight':
          e.preventDefault();
          nextImage();
          break;
        case 'Escape':
          e.preventDefault();
          const bsModal = bootstrap.Modal.getInstance(modal);
          if (bsModal) bsModal.hide();
          break;
      }
    });

    // Modal events
    modal.addEventListener('hidden.bs.modal', () => {
      hideLoading();
      if (galleryImageInfo) {
        galleryImageInfo.classList.remove('show');
      }
      document.body.style.overflow = '';
    });

    modal.addEventListener('shown.bs.modal', () => {
      document.body.style.overflow = 'hidden';
    });
  }

  // Initialize
  initializeGallery();
  setupEventListeners();
}
